import React, { createContext, useContext, useState } from 'react';
import { User } from '../types/user';

interface NavigationContextType {
  isSidebarCollapsed: boolean;
  setIsSidebarCollapsed: (value: boolean) => void;
  user: User | null;
  logout: () => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider: React.FC<{ children: React.ReactNode; user: User; onLogout: () => void }> = ({ children, user, onLogout }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  
  const navigationItems = [
    {
      name: 'Contacts',
      icon: 'contacts',
      items: [
        {
          name: 'All contacts',
          path: '/contacts'
        },
        {
          name: 'My Groups',
          path: '/contacts/groups'
        }
      ]
    },
    {
      name: 'Templates',
      icon: 'templates',
      items: [
        {
          name: 'Create Template',
          path: '/templates/create'
        },
        {
          name: 'My Templates',
          path: '/templates'
        }
      ]
    },
  ];

  const logout = () => {
    try {
      // Future-proof: clear any token persisted locally if used
      if (typeof window !== 'undefined') {
        localStorage.removeItem('authToken');
        sessionStorage.removeItem('authToken');
      }
    } catch {}
    onLogout();
  };

  return (
    <NavigationContext.Provider value={{ isSidebarCollapsed, setIsSidebarCollapsed, user, logout }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
}; 